// Vendor imports
const React = require('react')

function usePropsCallback(props, callbackKey) {
  // Store props in a ref so that we can re-use the same callback
  const propsRef = React.useRef()
  propsRef.current = props
  return React.useCallback(
    () => {
      const callback = propsRef.current[callbackKey]
      if (callback) {
        callback({ ...propsRef.current })
      }
    },
    [ callbackKey ]
  )
}

function usePropsEventCallback(props, callbackKey) {
  // Store props in a ref so that we can re-use the same callback
  const propsRef = React.useRef()
  propsRef.current = props
  return React.useCallback(
    event => {
      const callback = propsRef.current[callbackKey]
      if (callback) {
        event.preventDefault()
        event.stopPropagation()
        callback({ ...propsRef.current, event })
      }
    },
    [ callbackKey ]
  )
}

module.exports = {
  usePropsCallback,
  usePropsEventCallback
}
